import "webrtc-adapter";
import MediaStreamRecorder from "msr";
import getUserMedia from "getusermedia";
import hark, { Harker } from "hark";
import EventEmitter from "events";

export default class AudioMedia extends EventEmitter{

    /**
     * @type {MediaStream|undefined}
     * @protected
     */
    _mediaStream;

    /**
     * @type {MediaStreamRecorder|undefined}
     * @protected
     */
    _mediaRecorder;

    /**
     * @type {Harker|undefined}
     * @protected
     */
    _hark;

    _timeSlice;

    _state;

    static get OPEN(){
        return 0;
    }

    static get CLOSE(){
        return 1;
    }

    get state(){
        return this._state;
    }

    constructor(timeSlice){
        super();
        this._timeSlice = timeSlice;
        this._state = AudioMedia.CLOSE;
    }

    async open(){
        try{
            this._mediaStream = await new Promise((resolve, reject) => {
                getUserMedia({audio: true}, function (err, stream) {
                    if (err) {
                       reject(err);
                    } else {
                       resolve(stream);
                    }
                });
            });

            this._hark = hark(this._mediaStream, {
                threshold: -70
            });

            this._hark.on('stopped_speaking', () => this.emit('stopped_speaking'));

            this._mediaRecorder = this._createMediaRecorder(this._mediaStream);
            this._mediaRecorder.start(this._timeSlice);

            this._state = AudioMedia.OPEN;

        }catch(err) {
            this._state = AudioMedia.CLOSE;
            console.error(err);
        };
    }

    close(){
        this._hark?.stop();
        this._mediaStream?.getTracks().forEach(track => track.stop()); // 關閉stream
        this._mediaRecorder?.stop();
        this._state = AudioMedia.CLOSE;
    }

    /**
     * @param {MediaStream} stream
     * @returns {MediaStreamRecorder}
     */
    _createMediaRecorder(stream){
        const mediaRecorder = new MediaStreamRecorder(stream);
        mediaRecorder.audioChannels = 1;
        mediaRecorder.mimeType = 'audio/pcm';
        mediaRecorder.ondataavailable = (blob) => this.emit('dataavailable', blob);

        return mediaRecorder;
    }
}
